exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n* {\n    font-family: 'Roboto', sans-serif;\n}\n.loading-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1000;\n    background-color: rgba(0,0,0,0.4);\n    -webkit-transition: opacity 0.5s;\n    transition: opacity 0.5s;\n}\n.loading-dialog {\n    width: 300px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n}\n.btn-height {\n    line-height: 48px;\n}\n.company-name {\n    display: inline-block;\n    width: 100%;\n    border-bottom: 1px solid #444;\n}\n", ""]);

// exports
